interface Props {
    text: string;
    description: string;
    onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

export function MarkDoneItem({ text, description, onClick }: Props) {
    return (
        <button
            type="button"
            className="flex flex-col gap-1 text-left p-2 hover:bg-accent/50 rounded-sm "
            tabIndex={0}
            onClick={onClick}
        >
            <p className="font-medium">{text}</p>
            <p className="text-sm text-muted-foreground">{description}</p>
        </button>
    );
}
